(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('teamwork', {
            parent: 'app',
            url: '/teamwork?page&issuefilter',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/teamwork/teamwork.html',
                    controller: 'TeamworkController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                issuefilter: {
                    value: 'myissues',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        issuefilter: $stateParams.issuefilter,
         
                        search: $stateParams.search
                    };
                }],
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('redmine');
                    return $translate.refresh();
                }]
            }
        })
        .state('teamwork.new_issue', {
            parent: 'teamwork',
            url: '/new_issue',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/teamwork/redmine-createticket-dialog.controller.html',
                    controller: 'RedmineCreateTicketController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nom: null,
                                codeAgence: null,
                                devise: null,
                                enteteFacture: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('teamwork', null, { reload: true });
                }, function() {
                    $state.go('teamwork');
                });
            }]
        });
        
        
    }
})();
